<div class="">
    @if (hourLineData.length && showLabel) {
<label class="mt-1 bold page-sub-heading" style="float: left; padding: 2px 0px;">Time Seeker:  &nbsp;</label>
}
    <ul class="hourline">
        @for (hourRow of hourLineData; track hourRow; let ii = $index) {

            <!-- <li [class.left]="i === 0" *ngIf="hourRow.dayChange && i == 0">
                <span>
                    May
                </span>
                <div class="">
                    {{ hourRow.dayChange }}
                </div>
            </li> -->
            <!-- [ngbTooltip]="((hourRow.dayChange && i == 0) || (hourRow.dayChange && i !== 0)) ? month[hourRow.dayMonth] : ''"  -->
            @if (hourRow.count > 0 && !((hourRow.dayChange && ii === 0) || (hourRow.dayChange && ii !== 0))) {
<li (click)="onTimeClick(hourRow, ii)" [class.selected]="activeSeeker.includes(hourRow.ts)" [class.avail]="hourRow.count > 0" [class.right]="ii === (hourLineData.length - 1)" [class.left]="ii === 0">
                <div class="hour">{{ hourRow.label === 0 ? '12' : hourRow.label }}</div>
                <u>{{ hourRow.day }}</u>
            </li>
}
            @if (hourRow.count === 0 && !((hourRow.dayChange && ii === 0) || (hourRow.dayChange && ii !== 0))) {
<li (click)="onTimeClick(hourRow, ii)" [class.selected]="activeSeeker.includes(hourRow.ts)" [class.left]="ii === 0" [class.right]="ii === (hourLineData.length - 1)">
                <div class="hour">{{ hourRow.label === 0 ? '12' : hourRow.label }}</div>
                <u>{{ hourRow.day }}</u>
            </li>
}
            @if (hourRow.count > 0 && ((hourRow.dayChange && ii === 0) || (hourRow.dayChange && ii !== 0))) {
<li [ngbTooltip]="hourRow.dayChange + ' ' + month[hourRow.dayMonth]" (click)="onTimeClick(hourRow, ii)" [class.selected]="activeSeeker.includes(hourRow.ts)" [class.avail]="hourRow.count > 0" [class.right]="ii === (hourLineData.length - 1)" [class.left]="ii === 0">
                <div class="hour">{{ hourRow.label === 0 ? '12' : hourRow.label }}</div>
                <u>{{ hourRow.day }}</u>
            </li>
}
            @if (hourRow.count === 0 && ((hourRow.dayChange && ii === 0) || (hourRow.dayChange && ii !== 0))) {
<li [ngbTooltip]="hourRow.dayChange + ' ' + month[hourRow.dayMonth]" (click)="onTimeClick(hourRow, ii)" [class.selected]="activeSeeker.includes(hourRow.ts)" [class.left]="ii === 0" [class.right]="ii === (hourLineData.length - 1)">
                <div class="hour">{{ hourRow.label === 0 ? '12' : hourRow.label }}</div>
                <u>{{ hourRow.day }}</u>
            </li>
}
            <!-- <li *ngIf="hourRow.dayChange && i !== 0">
                <div class="">
                    {{ hourRow.dayChange }}
                </div>
            </li> -->
        
}
    </ul>
</div>